import { VT911_CORE } from '@rsos/capstone/src/constants/capabilities';
import { VIDEO_TO_911_CORE } from '@rsos/capstone/src/constants/permissionNames';
import { SinatraState, selectUserPermissionsByApp } from '@rsos/sinatra';
import { PsapState } from '../capstone/psapInfo/psapInfoSlice';

export const isVT911CoreEnabled = (state: {
  sinatra: SinatraState;
  psaps: PsapState;
}) => {
  const user = state.sinatra.user;
  const currentPSAP = state.psaps.currentPSAP;
  const permissions =
    user.profile && selectUserPermissionsByApp(user, 'capstone');

  return Boolean(
    currentPSAP?.activeCapabilities?.[VT911_CORE] &&
      permissions?.includes(VIDEO_TO_911_CORE),
  );
};
